module.exports = __webpack_public_path__ + "img/expoglitter_0939_violet.51ef5d1d.jpg";